import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import { isIos } from '@/utils'

import visitor from './visitor'

Vue.use(Router)

const router = new Router({
    mode:'history',
    routes: [
        {
            path:'/',
            redirect:'/index.html'
        },
        {
            path: '/index.html',
            name: 'index',
            component: () => import('@/page/index'),
        },
    
        {
            path:'/activity/detail.html',
            name:'activity-detail',
            component:() => import('@/page/activity/detail'),
        },
        {
            path:'/activity/all-comments.html',
            name:'activity-comments',
            component:() => import('@/page/activity/total-comment.vue'),
            meta: { slide: true }
        },
        {
            path:'/news/detail.html',
            name:'infomation-detail',
            component:() => import('@/page/infomation/detail'),
            meta: { slide: true }
        },
        // 停车缴费
        {
            path:'/park/index.html',
            name:'park-index',
            component:() => import('@/page/park/index')
        },
        {
            path:'/park/no-license-in.html',
            name:'no-license-enter',
            component:() => import('@/page/park/no-license-enter')
        },
        {
            path:'/park/no-license-exit.html',
            name:'no-license-enter',
            component:() => import('@/page/park/no-license-enter')
        },
        {
            path:'/park/pay-fee-newsee.html',
            name:'park-pay-fee-newsee',
            component:() => import('@/page/park/pay-fee-newsee'),        
            meta: { slide: true }
        },
        {
            path:'/park/pay-fee.html',
            name:'park-pay-fee',
            component:() => import('@/page/park/pay-fee'),        
            meta: { slide: true }
        },
        {
            path:'/park/pay-success.html',
            name:'park-pay-success',
            component:() => import('@/page/park/pay-success')
        },    
        {
            path:'/park/no-license-in.html',
            name:'no-license-enter',
            component:() => import('@/page/park/no-license-enter')
        },  
        {
            path:'/park/get-coupon.html',
            name:'get-coupon',
            component:() => import('@/page/park/get-coupon')
        },  
        {
            path:'/park/get-coupon-result.html',
            name:'get-coupon-result',
            component:() => import('@/page/park/get-coupon-result')
        },  
        {
            path:'/park/coupon-list.html',
            name:'coupon-list',
            component:() => import('@/page/park/coupon-list')
        },  
        {
            path:'/activity/turntable.html',
            name:'',
            component:() => import('@/page/activity/lottery-turntable'),
            meta: { slide: true }
        },
        {
            path:'/activity/goldenegg.html',
            name:'',
            component:() => import('@/page/activity/golden-egg'),
            meta: { slide: true }
        },
        // 父话题详情页
        {
            path:'/topic/detail.html',
            name:'topic',
            component:() => import('@/page/topic/detail'),
            meta:{slide:true}
        },
        // 子话题详情页
        {
            path:'/sub-topic/detail.html',
            name:'topic',
            component:() => import('@/page/topic/sub-topic-detail'),
            meta: { slide: true }
        },
        {
            path:'/topic/list.html',
            name:'topic-list',
            component:() => import('@/page/topic/topic-list'),
            meta: { slide: true }
        },
        {
            path:'/topic/total-comments.html',
            name:'total-comments',
            component:() => import('@/page/topic/total-comments'),
            meta: { slide: true }
        },
        {
            path:'/topic/total-replys.html',
            name:'total-comments',
            component:() => import('@/page/topic/total-replys')
        },
        
        //访客预约
        ...visitor,

        //问卷
        {
            path:'/wj/index.html',
            name:'wj-index',
            component:() => import('@/page/wj/index'),
            meta: { slide: true }
        },
        {
            path:'/wj/list',
            name:'wj-list',
            component:() => import('@/page/wj/list'),
            meta: { slide: true }
        },
        {
            path:'/wj/question.html',
            name:'wj-question',
            component:() => import('@/page/wj/question'),
            meta: { slide: true }
        },
        {
            path:'/wj/submitSuccess.html',
            name:'wj-submitSuccess',
            component:() => import('@/page/wj/submitSuccess'),
            meta: { slide: true }
        },
        {
            path:'/wj/interruptAndStop.html',
            name:'wj-interruptAndStop',
            component:() => import('@/page/wj/interruptAndStop'),
            meta: { slide: true }
        },
        {
            path:'/wj/lotteryTurntable.html',
            name:'wj-lotteryTurntable',
            component:() => import('@/page/wj/lottery-turntable'),
            meta: { slide: true }
        },
        {
            path:'/wj/goldenEgg.html',
            name:'wj-goldenEgg',
            component:() => import('@/page/wj/golden-egg'),
            meta: { slide: true }
        },
        
        // 评价
        {
            path:'/eval/index.html',
            name:'eval-index',
            component:() => import('@/page/evaluation/index'),
            meta:{slide:true}
        },
        // ios app下载
        {
            path:'/download',
            redirect:'/download/index.html'
        },
        {
            path:'/download/index.html',
            name:'download-index',
            component:() => import('@/page/download/pc-index'),
            meta: { slide: true }
        },
        {
            path:'/download/community',
            name:'community',
            component:() => import('@/page/download/mobile'),
            meta: { slide: true }
        },
        {
            path:'/download/steward',
            name:'steward',
            component:() => import('@/page/download/mobile'),
            meta: { slide: true }
        },
        {
            path:'/download/ehome',
            name:'ehome',
            component:() => import('@/page/download/mobile'),
            meta: { slide: true }
        },
        {
            path:'/download/ruizhu',
            name:'ruizhu',
            component:() => import('@/page/download/mobile'),
            meta: { slide: true }
        },
        // 云朵app升级 调查问卷
        {
            path:'/operation-theme/app-questionnaire/v2.html',
            name:'app-questionnaire-v2',
            component:() => import('@/page/operation-theme/app-questionnaire/v2'),
            meta: { slide: true }
        },
        {
            path:'/operation-theme/app-questionnaire/v3.html',
            name:'app-questionnaire-v3',
            component:() => import('@/page/operation-theme/app-questionnaire/v3'),
            meta: { slide: true }
        },
        {
            // 管家满意度等待页面
            path: '/operation-theme/app-questionnaire/waiting.html',
            name: 'app-questionnaire-waiting',
            component: () => import('@/page/operation-theme/app-questionnaire/waiting'),
            meta: { slide: true }
        },
        {
            path:'/operation-theme/app-questionnaire/qrcode.html',
            name:'app-questionnaire-qrcode',
            component:() => import('@/page/operation-theme/app-questionnaire/qrcode'),
            meta: { slide: true }
        },

        // 管家账单缴费，预存
        {
            path:'/resident-bill/bill-pay.html',
            name: 'resident-bill-pay',
            component: () => import('@/page/resident-bill/bill-pay'),
            meta: {slide: true, keepAlive: true}
        },
        // 管家 预存
        {
            path:'/resident-bill/store-pay.html',
            name: 'resident-store-pay',
            component: () => import('@/page/resident-bill/store-pay'),
            meta: {slide: true, keepAlive: true}
        },        
        {
            path:'/resident-bill/store-plan.html',
            name: 'resident-store-plan',
            component: () => import('@/page/resident-bill/store-plan-list'),
            meta: {slide: true , keepAlive: true}
        },        
        // 缴费支付确认页面
        {
            path:'/resident-bill/bill-pay-confirm.html',
            name: 'bill-pay-confirm',
            component: () => import('@/page/resident-bill/bill-pay-confirm'),
            meta: {slide: true, keepAlive: true}
        },
        // 预存支付确认页面
        {
            path:'/resident-bill/store-pay-confirm.html',
            name: 'store-pay-confirm',
            component: () => import('@/page/resident-bill/store-pay-confirm'),
            meta: {slide: true , keepAlive: true}
        },
        // 支付结果页面
        {
            path:'/resident-bill/pay-result.html',
            name: 'resident-pay-result',
            component: () => import('@/page/resident-bill/pay-result'),
            meta: {slide: true}
        },

        //静态页面
        {
            path:'/html/privacy.html',
            name:'privacy',
            component:() => import('@/page/html/privacy'),
            meta: { slide: true }
        },
        {
            path:'/html/privacy-detail.html',
            name:'privacy',
            component:() => import('@/page/html/privacy-detail'),
            meta: { slide: true }
        },
        // 预存协议页面
        {
            path:'/resident-bill/store-agreement.html',
            name: 'resident-store-agreement',
            component: () => import('@/page/resident-bill/store-agreement'),
            meta: {slide: true, keepAlive: true}
        },
        // 常见问题页面
        {
            path:'/resident-bill/question.html',
            name: 'resident-store-question',
            component: () => import('@/page/resident-bill/question'),
            meta: {slide: true, keepAlive: true}
        },


        // ioc
        {
            path:'/ioc/weather.html',
            name:'ioc-weather',
            component:() => import('@/page/ioc/weather'),
            meta: { slide: true }
        },

    ]
});


// 获取真实有效微信签名URL
function getWechatSignUrl(to){
    if(isIos()) {
      return window.location.href;
    } else {
      // 此处$appHost需要自行处理
      return process.env.SERVER_NAME + to.fullPath
    }
}

const pageStacks = [];
router.beforeEach((to, from, next) => {
    // 是否使用过渡动画
    const index = pageStacks.indexOf(to.path);
    let direction = '';


    if (index !== -1) {
        pageStacks.splice(index+1, pageStacks.length - index - 1);

        if (from.meta.slide) {
            direction = 'slide-right'
        }
    } else {
        pageStacks.push(to.path);
        
        if (to.meta.slide && !to.query.from) {
            direction = 'slide-left'
        }
    }

    store.commit('SET_VIEWDIRECTION', direction);
    store.commit('SET_WECHATSIGNURL', getWechatSignUrl(to));

    // 解决ios微信config失败问题
    // let u = navigator.userAgent;
    // let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    // if (isiOS && to.path !== location.pathname) {
    //     // 此处不可使用location.replace
    //     location.assign(to.fullPath)
    // } else {
    //     next()
    // }
    next()
})


export default router



// WEBPACK FOOTER //
// ./src/router/index.js